// src/components/received-quotation/reject-modal.tsx
import { Button, Flex, Modal, Textarea } from "@mantine/core"
import { ConfirmNote } from "@dehub/theme"
import { useState } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  opened: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
  loading?: boolean
}

export function RejectModal({ opened, onClose, onConfirm, loading = false }: Props) {
  const { t } = useTranslation(["quotation", "common"])
  const [reason, setReason] = useState("")

  const handleClose = () => {
    setReason("")
    onClose()
  }

  return (
    <Modal opened={opened} onClose={handleClose} title={t("detail.rejectTitle")} centered radius="lg">
      <Textarea
        label={t("detail.rejectReasonLabel")}
        placeholder={t("detail.rejectReasonPlaceholder")}
        value={reason}
        onChange={(e) => setReason(e.currentTarget.value)}
        maxLength={500}
        autosize
        minRows={3}
        maxRows={6}
      />
      <ConfirmNote helpKey="order.received-quotation-detail.confirm.reject" />
      <Flex justify="flex-end" gap="sm" mt="lg">
        <Button variant="default" onClick={handleClose} disabled={loading}>
          {t("common:cancel")}
        </Button>
        <Button color="red" onClick={() => onConfirm(reason.trim())} loading={loading}>
          {t("detail.rejectButton")}
        </Button>
      </Flex>
    </Modal>
  )
}
